<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-first-text-section
    t-section
      template(v-if="lng === 'ua'")
        +e.P.text Індекс сприйняття корупції (Corruption Perceptions Index, СРІ) - показник, який з 1995 року розраховується міжнародною організацією <a class="the-first-text-section__link" href="https://www.transparency.org/research/cpi/overview" target="_blank">Transparency International</a>. Сама організація не проводить власних опитувань. Індекс розраховують на основі 13 досліджень авторитетних міжнародних установ і дослідницьких центрів. Для визначення оцінки України використано 9 джерел. Ключовим показником Індексу є кількість балів, а не місце в рейтингу. Мінімальна оцінка (0 балів) означає, що корупція фактично підміняє собою державу, максимальна (100 балів) свідчить про те, що корупція майже відсутня в житті суспільства. Індекс оцінює корупцію лише в державному секторі.
      template(v-if="lng === 'en'")
        +e.P.text {{content.textBlock1Text}}
</template>

<script>
import { mapGetters } from 'vuex';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';

export default {
  name: 'the-first-text-section',

  computed: {
    ...mapGetters({
      content: 'getContent',
      lng: 'lng',
    }),
  },

  components: {
    TSection,
    TH2,
    TH3,
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.the-first-text-section {
  &__text {
    color: #ffffff;
    font-weight: 100;
  }

  &__link {
    text-decoration: none;
    color: #3695D8;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TheFirstTextSection/TheFirstTextSection.vue